import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Search from 'components/UI/PageSearch'
import { Header } from 'components/Modals/PlanItems/styles'
import { DrawerModal } from 'components/UI'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// themes
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
// view components
import RiskRecurrenceModal from 'components/Modals/RiskTransactionRecurrenceModal'
import SystemProcessesTable from 'components/PageComponents/Settings/SystemProcesses/components/Table'
import CreateSystemProcessButton from 'components/CTAs/CreateSystemProcess'
import SystemProcessDetailsDrawer from 'components/Modals/SystemProcessModal'

const SystemProcessesTableWrapper = styled.div`
  padding: 16px;
  overflow: auto;
`

const IconWrapper = styled.div`
  display: flex;
  margin-left: 16px;
  cursor: pointer;
`

const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  fontWeight: 'normal',
  gap: 12
} as any

const RiskTemplateSystemProcessesDrawer: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.RISK_TEMPLATE_SYSTEM_PROCESSES_MODAL })

  return (
    <DrawerModal width='800px' isOpen={isOpen} hideModal={hideModal} data-testid='system-processes-drawer'>
      <Header style={headerStyles}>
        <Search name='search' />
        <CreateSystemProcessButton />
        <IconWrapper>
          <CloseRoundedIcon onClick={hideModal} />
        </IconWrapper>
      </Header>

      <SystemProcessesTableWrapper>
        <SystemProcessesTable />
      </SystemProcessesTableWrapper>

      <RiskRecurrenceModal />
      <SystemProcessDetailsDrawer />
    </DrawerModal>
  )
}

export default RiskTemplateSystemProcessesDrawer
